import { useRecoilValue } from 'recoil'
import { useCallback, useEffect } from 'react'
import useItemsSetter from 'recoil/useItemsSetter'
import useTableWithRequest from 'shared/Table/useTableWithRequest'
import Table from 'shared/Table'
import checkpointsTableAtom from './checkpointsTable.atom'
import checkpointsTableFields from './checkpointTableFields'
import projectCheckpointsApi from '../../projectCheckpoints.api'
import { IProjectCheckpoint } from '../../projectCheckpoints.types'
import { useNavigate } from 'react-router-dom'
import eventBus from 'services/eventBus'

const CheckpointsTable = () => {
  const state = useRecoilValue(checkpointsTableAtom)
  const navigate = useNavigate()
  const itemsSetter = useItemsSetter(checkpointsTableAtom)

  useEffect(() => {
    const unsub = eventBus.sub('projectCheckpoints.updated', ({ id, updates }) => {
      itemsSetter((prevItems) => prevItems.map((item) => (item.id === id ? { ...item, ...updates } : item)))
    })
    return unsub
  }, [itemsSetter])

  const fetcher = useCallback((_params: Record<string, any>) => {
    return projectCheckpointsApi.getList()
  }, [])

  const tableCtrl = useTableWithRequest({
    dataFetcher: fetcher,
    fields: checkpointsTableFields,
    itemKey: 'id',
    items: state.items,
    setItems: itemsSetter,
    tableKey: 'project-checkpoints',
  })

  const handleClick = useCallback((val: IProjectCheckpoint) => {
    navigate(`/admin/project-checkpoints/${val.id}`)
  }, [])

  return (
    <Table
      {...tableCtrl}
      items={tableCtrl.orderedItems}
      handleSelect={tableCtrl.selectedCtrl.setSelected}
      selected={tableCtrl.selectedCtrl.selectedIndexes as Set<keyof IProjectCheckpoint>}
      handleSelectAll={tableCtrl.selectedCtrl.setSelectAll}
      itemKey='id'
      onCLick={handleClick}
      selectEnabled={false}
    />
  )
}

export default CheckpointsTable
